import { cn } from "@/lib/utils";

interface NotificationDotProps {
  className?: string;
  label?: string;
}

export function NotificationDot({ className, label = "New" }: NotificationDotProps) {
  return (
    <span data-testid="notification-dot" className={cn("relative flex size-2 shrink-0", className)}>
      <span aria-hidden="true" className="notification-dot-ring absolute inset-0 rounded-full bg-error-600" />
      <span aria-hidden="true" className="relative size-2 rounded-full bg-error-600" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
